import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/toaster/showToast";
import DistributorRewardForm from "../Layout/DistributorRewardForm";
import { useParams } from "react-router-dom";
import { useGetRewardEntryInLedgerQuery, useUpdateRewardEntryInLedgerMutation } from "src/services/RewardService";
import { CircularProgress } from "@mui/material";

export type DistributorRewadFormValues = {
  applicationType: string;
  rewardPoints: string;
  transactionType: string;
  remark: string;
  otp:string
};

type Props = {
  onClose: () => void;
  RewardId: string;
};

const EditDistributorRewardWrapper = ({ onClose, RewardId }: Props) => {
  const [rewardData, setRewardData] = useState<any>({});
  const [wantToDisabledFiled  , setWantToDisabledFiled] = useState(false)
  const [updateEntryInReward] = useUpdateRewardEntryInLedgerMutation();
  const { distributorId } = useParams();
  const { data, isLoading, isFetching } =
  useGetRewardEntryInLedgerQuery(RewardId);

  useEffect(() => {
    if (!isFetching && !isLoading) {
      setRewardData(data?.data);
    }
  }, [isFetching, isLoading, data]);
  // Form Initial Values
  const initialValues: DistributorRewadFormValues = {
    applicationType: rewardData?.applicationType,
    rewardPoints: rewardData?.points,
    transactionType: rewardData?.rewardTransactionType,
    remark: rewardData?.logs,
    otp:'',
  };

  // Validation Schema
  const validationSchema = object().shape({
    applicationType: string().required("Please enter applicationType"),
    rewardPoints: string().required("Please enter point"),
    transactionType: string().required("Please enter transactionType"),
    remark: string().required("Please enter remark"),
    otp: string().required("Please enter otp"),

  });

  // Handle Submit
  const handleSubmit = (
    values: DistributorRewadFormValues,
    { setSubmitting, resetForm }: FormikHelpers<DistributorRewadFormValues>
  ) => {
    const formatedvalues = {
      ...values,
      userId: distributorId,
    };
    updateEntryInReward({
      body: formatedvalues,
      id: RewardId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
            setWantToDisabledFiled(false)
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form> 
             {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <DistributorRewardForm
             setWantToDisabledFiled={setWantToDisabledFiled}
             wantToDisabledFiled={wantToDisabledFiled}
              formikProps={formikProps}
              onClose={onClose}
              formType="Edit"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditDistributorRewardWrapper;
